<template>
  <v-dialog :value="isModalActive" max-width="500" @input="inputModal">
    <v-card
      id="account-cancellation-modal-card"
      class="pb-1 pr-2"
      :color="$vuetify.theme.dark ? 'dark_backgroundDarkBlue' : undefined"
    >
      <v-card-title>
        {{ $t(`views.myAccount.accountCancellationModal.title`) }}
      </v-card-title>
      <v-card-text class="py-0 pt-3">
        <div class="account-cancellation-modal-card-text">
          {{ $t(`views.myAccount.accountCancellationModal.text`) }}
        </div>
        <div class="account-cancellation-modal-card-options">
          <v-radio-group v-model="reason">
            <v-radio
              :label="$t(`views.myAccount.accountCancellationModal.features`)"
              value="features"
            ></v-radio>
            <template v-if="reason === 'features'">
              <v-textarea
                v-model="otherText"
                filled
                :label="$t(`views.myAccount.accountCancellationModal.featuresReason`)"
                auto-grow
                class="mb-3 pa-0"
                hide-details
                rows="2"
                maxlength="1500"
              ></v-textarea>
            </template>
            <v-radio
              :label="$t(`views.myAccount.accountCancellationModal.lost`)"
              value="lost"
            ></v-radio>
            <template v-if="reason === 'lost'">
              <v-textarea
                v-model="otherText"
                filled
                :label="$t(`views.myAccount.accountCancellationModal.lostReason`)"
                auto-grow
                class="mb-3 pa-0"
                hide-details
                rows="2"
                maxlength="1500"
              ></v-textarea>
            </template>
            <v-radio
              :label="$t(`views.myAccount.accountCancellationModal.price`)"
              value="price"
            ></v-radio>
            <template v-if="reason === 'price'">
              <v-textarea
                v-model="otherText"
                filled
                :label="$t(`views.myAccount.accountCancellationModal.priceReason`)"
                auto-grow
                class="mb-3 pa-0"
                hide-details
                rows="2"
                maxlength="1500"
              ></v-textarea>
            </template>
            <v-radio
              :label="$t(`views.myAccount.accountCancellationModal.other`)"
              value="other"
            ></v-radio>
            <template v-if="reason === 'other'">
              <v-textarea
                v-model="otherText"
                filled
                :label="$t(`views.myAccount.accountCancellationModal.otherReason`)"
                auto-grow
                class="mb-3 pa-0"
                hide-details
                rows="2"
                maxlength="1500"
              ></v-textarea>
            </template>
          </v-radio-group>
        </div>
      </v-card-text>
      <v-card-actions class="mt-0 pt-0">
        <v-spacer></v-spacer>
        <v-btn class="mr-1" color="primary" outlined :disabled="loading" @click="closeModal()">
          {{ $t(`views.myAccount.accountCancellationModal.close`) }}
        </v-btn>
        <v-btn
          color="primary"
          :disabled="saveDisabled"
          :loading="loading"
          @click="cancelSubscription"
        >
          {{ $t(`views.myAccount.accountCancellationModal.goToCancel`) }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import gtag from '@/lib/gtag'
import BillingMixin from '@/views/components/account/BillingMixin.js'
import modalMixin from '@/views/components/core/modalMixin.js'
import { createCancellation } from '@/lib/api'

export default {
  mixins: [modalMixin, BillingMixin],
  data: () => ({
    loading: false,
    reason: null,
    otherText: null,
  }),
  computed: {
    saveDisabled() {
      return !this.reason || !this.otherText || this.otherText === ''
    },
  },
  methods: {
    resetForm() {
      this.reason = null
      this.otherText = null
    },
    async cancelSubscription() {
      try {
        this.loading = true
        const reason = this.reason
        const otherText = this.otherText ? this.otherText : undefined
        await createCancellation({
          reason,
          otherText,
        })
        this.loading = false

        gtag.pageview({
          pagePath: `/account/billing/cancel/success`,
          pageTitle: `account|billing|cancel|success`,
          pageContentGroup: 'modal',
        })

        this.goToCustomerPortal()
      } catch (error) {
        this.$root.$snackbar.error({ text: this.$t('common.saveError') })
        this.loading = false
      }
    },
  },
}
</script>

<style lang="scss">
#account-cancellation-modal-card {
  .account-cancellation-modal-card-text {
    font-size: 15px;
  }
  .account-cancellation-modal-card-options {
    .v-label {
      color: black;
    }
    .v-label.theme--dark {
      color: #a5a5a5;
    }
  }
}
</style>
